export default __webpack_public_path__ + "static/media/black-giftcard.0fd9b3cf.svg";